<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN'
    if (geo.geometry.lat) {
        addressObj.lat = geo.geometry.lat
    } else return null
    if (geo.geometry.lng) {
        addressObj.lng = geo.geometry.lng
    } else return null
    return addressObj
}

const ADDRESS_FIELDS = ['cep', 'address', 'number', 'complement', 'neighborhood', 'city', 'state', 'ibge', 'gia', 'lat', 'lng']

const hasMeaningfulAddress = address => ADDRESS_FIELDS.some(field => {
    const value = address?.[field]
    return value !== null && value !== undefined && String(value).trim().length > 0
})

export default {
    init: async payload => {
        payload.domain = Endpoints.domain
        payload.data.timezone = Common.resolveTimezoneId(payload.data?.timezone || 'America/Sao_Paulo')

        if (!payload.data?.address?._id) {
            payload.clearAddress()
        }

        await payload.loadTimezones()
    },
    methods: {
        loadTimezones: async function () {
            this.timezones = await Services.getTimezones(this)
            this.ensureCurrentTimezoneOption()
        },
        ensureCurrentTimezoneOption() {
            this.data.timezone = Common.resolveTimezoneId(this.data?.timezone || 'America/Sao_Paulo')

            if (!this.timezones?.some(item => item._id === this.data.timezone)) {
                const timezoneOption = Common.buildTimezoneOption(this.data.timezone)
                if (timezoneOption) {
                    this.timezones.push({
                        _id: timezoneOption._id,
                        name: timezoneOption.name,
                    })
                }
            }
        },
        inputCep() {
            if (this.data.address.cep.length === 9) this.loadInfosByCEP()
        },
        clearCep() {
            const cep = this.data?.address?.cep
            const address = {
                cep: cep,
                address: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                state: '',
                ibge: '',
                gia: '',
            }
            this.data.address = address
        },
        handleCEPDelete(e) {
            if (e.key === 'Backspace' || e.key === 'Delete') {
                this.clearCep()
            }
        },
        clearAddress() {
            const address = {
                cep: this.data?.address?.cep,
                address: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                state: '',
                ibge: '',
                gia: '',
            }
            this.data.address = address
        },
        loadInfosByCEP() {
            Request.do(
                this,
                'get',
                {},
                {},
                `${Endpoints.cep.find}${this.data.address.cep}/json`,
                response => {
                    if (response && !response.erro) {
                        this.removeRequiredField('allAddress')
                        this.data.address.address = response.logradouro
                        this.data.address.neighborhood = response.bairro
                        this.data.address.city = response.localidade
                        this.data.address.state = response.uf
                        this.data.address.ibge = response.ibge
                        this.data.address.gia = response.gia
                        this.$refs.numberField.focus()
                    } else {
                        this.clearAddress()
                    }
                },
                () => {
                    this.clearAddress()
                },
            )
        },
        selectDocument() {
            this.data.document = ''
        },
        clearForm() {
            this.errors = []
            this.data = JSON.parse(JSON.stringify(this.companyObj))
            this.data.timezone = Common.resolveTimezoneId(this.data.timezone || 'America/Sao_Paulo')
            this.ensureCurrentTimezoneOption()
            this.file = null
            if (this.$refs.file) this.$refs.file.value = null
            this.isLoading = false
        },
        // O payload sai de um clone: o template faz bind direto em `data.address.cep`,
        // então remover nós do estado durante o save derruba o render e o
        // ErrorBoundary toma a tela com o registro já salvo no backend.
        async save({ omitAddress = false } = {}) {
            let formData = new FormData()
            const payloadData = {
                ...this.data,
                timezone: Common.resolveTimezoneId(this.data?.timezone),
            }

            this.data.timezone = payloadData.timezone

            if (omitAddress) delete payloadData.address

            if (!payloadData.personType) delete payloadData.personType

            formData.append('file', this.file)
            formData.append('jsonData', JSON.stringify(payloadData))

            try {
                Request.do(
                    this,
                    this.data._id ? 'put' : 'post',
                    Request.getDefaultHeader(this),
                    formData,
                    `${Endpoints.companies.formData}${this.data._id ? this.data._id : ''}`,
                    response => {
                        if (response.status === 200) {
                            Common.show(this, 'bottom-right', 'success', this.data._id ? this.$t('str.form.update.success') : this.$t('str.form.create.success'))
                            const { _id, status, logoURL } = response?.result || {}
                            this.data._id = _id || this.data._id
                            this.data.status = status || this.data.status
                            this.data.logoURL = logoURL || this.data.logoURL
                            this.$registerEvent.$emit('refreshList')
                            this.closeModal()
                        }
                    },
                    () => {
                        this.isLoading = false
                        Common.show(this, 'bottom-right', 'warn', this.$t('str.form.update.generic.error'))
                    },
                )
            } catch {
                this.isLoading = false
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.update.generic.error'))
            }
        },
        archive() {
            try {
                Request.do(
                    this,
                    'DELETE',
                    Request.getDefaultHeader(this),
                    this.data,
                    `${Endpoints.companies.company}${this.data._id}`,
                    response => {
                        if (response.status === 200) {
                            Common.show(this, 'bottom-right', 'success', this.$t('str.form.archive.success'))
                            this.$registerEvent.$emit('refreshList')
                            this.closeModal()
                        }
                    },
                    () => {
                        Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
                    },
                )
            } catch {
                Common.show(this, 'bottom-right', 'warn', this.$t('str.form.archive.generic.error'))
            }
        },
        confirmArchive() {
            this.$swal({
                title: this.$t('str.are.you.sure'),
                text: this.$t('str.are.you.sure.archive'),
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: this.$t('str.title.archive'),
                cancelButtonText: this.$t('str.btn.cancel'),
                confirmButtonClass: 'btn me-5px btn-warning',
                cancelButtonClass: 'btn btn-default',
            }).then(result => {
                if (result.isConfirmed && result.value) {
                    this.archive()
                }
            })
        },
        checkRequiredField(field) {
            return this.errors.includes(field)
        },
        removeRequiredField(field) {
            if (field === 'allAddress') {
                this.errors = this.errors.filter(item => item !== 'cep' && item !== 'address' && item !== 'number' && item !== 'neighborhood' && item !== 'city' && item !== 'state')
            } else {
                this.errors = this.errors.filter(item => item !== field)
            }
        },
        async closeModal() {
            this.clearForm()
            this.$bvModal.hide('createCompanyModal')
        },
        async checkForm() {
            this.isLoading = true

            if (!this.data.name || this.data.name === '') {
                this.errors.push('name')
            }

            this.data.timezone = Common.normalizeTimezoneId(this.data.timezone || '')
            if (!this.data.timezone || this.data.timezone.length === 0) {
                this.errors.push('timezone')
            }
            // if (!this.data.address.cep || this.data.address?.cep?.length !== 9) {
            //     this.errors.push('cep')
            // }
            // if (!this.data.address.address && this.data.address.address === '') {
            //     this.errors.push('address')
            // }
            // if (!this.data.address.number && this.data.address.number === '') {
            //     this.errors.push('number')
            // }
            // if (!this.data.address.neighborhood && this.data.address.neighborhood === '') {
            //     this.errors.push('neighborhood')
            // }
            // if (!this.data.address.city && this.data.address.city === '') {
            //     this.errors.push('city')
            // }
            // if (!this.data.address.state && this.data.address.state === '') {
            //     this.errors.push('state')
            // }

            if (!this.errors || this.errors.length === 0) {
                this.isLoading = true

                if (!hasMeaningfulAddress(this.data?.address)) {
                    await this.save({ omitAddress: true })
                } else if (this.data?.address?.cep?.length !== 9) {
                    this.data.address.name = 'MAIN'
                    await this.save()
                } else {
                    this.loadGeolocation(
                        async () => {
                            await this.save()
                        },
                        async () => {
                            this.data.address.name = 'MAIN'
                            await this.save()
                        },
                    )
                }
            } else {
                this.isLoading = false
            }
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.data.address,
                `${Endpoints.addresses.geolocation}`,
                geoResponse => {
                    if (geoResponse.results.length == 0) {
                        return callbackError(this.$t('string.company.register.address.invalid'))
                    } else if (geoResponse.results.length == 1) {
                        let addressObj = instanceateAddress(state.data.address, geoResponse.results[0])
                        if (addressObj) {
                            return callbackSuccess(state.data)
                        } else {
                            return callbackError(state.$t('string.company.register.address.invalid'))
                        }
                    } else if (geoResponse.results.length > 1) {
                        state.addresses = geoResponse.results
                        return callbackError(state.$t('string.company.register.address.invalid'))
                    }
                },
                () => {
                    callbackError(state.$t('string.company.register.address.invalid'))
                },
            )
        },

        handleFileUpload() {
            this.file = this.$refs.file.files[0]
        },
        filterInvalidChars: Common.filterInvalidChars,
    },
}
</script>
